import { isTestEnv } from '../utils/env/isTestEnv';

export function sendToGTM(dataLayerEvent) {
  const hasDefinedDataLayer = typeof window === 'undefined' || !window.dataLayer;
  if (hasDefinedDataLayer && !isTestEnv) {
    console.error('[GTM] dataLayer is undefined');
    return;
  }
  window?.dataLayer?.push(dataLayerEvent);
}
